<!-- Mirrors bulk-tags-button.vue for the admin/intern bulk copy-to-account button + popup. -->
<template>
  <WrapWithHint class="control" :content="hintText">
    <div @click="onWrapperClick">
      <button ref="buttonRef" class="button" :class="buttonClasses" @click="toggle">
        <span class="icon">
          <i class="fa fa-copy"></i>
        </span>
        <span>Copy to account</span>
      </button>
    </div>
  </WrapWithHint>
</template>

<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import { h, ref, watchEffect } from "vue";
  import { onKeyStroke } from "@vueuse/core";

  import BulkCopyToAccountPanel from "./bulk-copy-to-account-panel.vue";
  import WrapWithHint from "../wrap-with-hint.vue";
  import { createOptionsPanel } from "../lib/use-bulk-actions.js";

  const props = defineProps({
    // Recipe search store. Must expose bulkCopyToAccount(targetUser) and selection.
    store: { type: Object, required: true },
    // Selection size. Drives enabled state, hint text, and button styling.
    count: { type: Number, required: true },
    hintEventName: { type: String, default: null },
  });

  const emit = defineEmits(["copied"]);

  const buttonRef = _ref(null);
  const openState = ref(false);

  const hintText = _computed(() => {
    if (props.count === 0) return "Select recipes to copy to another account";
    return null;
  });

  const buttonClasses = _computed(() => {
    if (openState.value) return ["is-link", "is-active"];
    if (props.count > 0) return ["is-outlined", "is-info"];
    return ["is-outlined", "click-disabled"];
  });

  watchEffect(() => {
    if (props.count === 0) {
      openState.value = false;
    }
  });

  const panel = createOptionsPanel({
    buttonRef: () => buttonRef.value,
    openState,
    isEnabled: () => props.count > 0,
    buildContent: (keyRef) => ({
      render: () =>
        h("div", { class: "box well" }, [
          h(BulkCopyToAccountPanel, {
            key: keyRef.value,
            store: props.store,
            count: props.count,
            onClose: toggle,
            onDone: onCopied,
          }),
        ]),
    }),
  });

  function toggle() {
    panel.toggle();
  }

  function onWrapperClick() {
    if (props.count === 0 && props.hintEventName) {
      document.dispatchEvent(new CustomEvent(props.hintEventName));
    }
  }

  function onCopied(message) {
    panel.hide();
    emit("copied", message);
  }

  onKeyStroke((ev) => {
    if (ev.key !== "Escape" || !panel.isOpen()) return;
    const active = document.activeElement;
    if (active && active.tagName === "INPUT") return;
    panel.hide();
  });
</script>
